var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class HeaderViewModelMobile {
    constructor(container) {
        this.routingUIManager = container.routingUIManager;
        this.appUIManager = container.appUIManager;
    }
    get mobilePageTitle() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return t("Sharing");
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return t("Details");
            case NamedRoutes.PATIENT_HISTORY.routeName:
            case NamedRoutes.PATIENT_HISTORY_DETAILS.routeName:
                return null;
            default:
                return null;
        }
    }
    get mobilePageText() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return t("Manage who can access your health records");
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return null;
            case NamedRoutes.PATIENT_HOME.routeName:
                return t("See your health history, all in one secure document.");
            default:
                return null;
        }
    }
    get headerGap() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return 16;
            case NamedRoutes.PATIENT_SHARING.routeName:
                return 40;
            default:
                return 0;
        }
    }
    get headerPaddingBottom() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING.routeName:
                return 12;
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return 0;
            default:
                return 0;
        }
    }
    get mobileOnBack() {
        var _a;
        switch ((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) {
            case NamedRoutes.PATIENT_SHARING_DETAILS.routeName:
                return () => this.routingUIManager.navigateTo(NamedRoutes.PATIENT_SHARING);
            case NamedRoutes.PATIENT_HISTORY_DETAILS.routeName:
                return () => this.routingUIManager.navigateTo(NamedRoutes.PATIENT_HISTORY);
            default:
                return null;
        }
    }
    get showLeftAlignedLogo() {
        var _a, _b;
        const routesWithLeftAlignedLogo = [NamedRoutes.PATIENT_SHARING_DETAILS.routeName, NamedRoutes.PATIENT_HISTORY_DETAILS.routeName];
        return routesWithLeftAlignedLogo.includes((_b = (_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) !== null && _b !== void 0 ? _b : "");
    }
    logoOnClick() {
        var _a;
        if (((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION.routeName) {
            this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_PATIENT);
        }
        else {
            this.appUIManager.navigateToHome();
        }
    }
}
__decorate([
    computed
], HeaderViewModelMobile.prototype, "mobilePageTitle", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "mobilePageText", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "headerGap", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "headerPaddingBottom", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "mobileOnBack", null);
__decorate([
    computed
], HeaderViewModelMobile.prototype, "showLeftAlignedLogo", null);
